import { convertToAddonFieldType } from 'automation-ui-action-features/object-type-properties/propertyUtils';
import PropertyFieldTypes from 'automation-ui-flow-core/fields/PropertyFieldTypes';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
export const getConvertedFieldType = (fieldType, type) => {
  switch (type) {
    case DATE_TIME:
      return PropertyFieldTypes.DATETIME;
    case 'currency_number':
    case 'json':
    case 'object_coordinates':
      return PropertyFieldTypes.ENUM;
    default:
      return fieldType ? convertToAddonFieldType(type, fieldType) : PropertyFieldTypes.ENUM;
  }
};